<div class="mb-2">
  <label class="secondary-details">{{
    'maw.linkPieces.shipmentUnlinkedPiecesList' | translate
  }}</label>
  <img class="float-right" src="assets/images/cancel.svg" alt="cancel" mat-dialog-close />
</div>
<div class="ls-2 custom-card">
  <p class="alert-msg p-1" *ngIf="this.pieceLevelLabelPrint && linkDisable">
    * {{ 'maw.linkPieces.shipmentLinkValidationLabel' | translate }}
    <a class="blue-link text-end" *ngIf="linkDisable" (click)="navToShipmentList(this.shipmentID)">
      {{ 'maw.linkPieces.goToShipmentList' | translate }}
    </a>
  </p>

  <div class="mb-2">
    <button [disabled]="linkDisable" class="primary-btn float-right mr-2" (click)="linkShipments()">
      {{ 'maw.linkPieces.link' | translate }}
    </button>
  </div>
  <br />
  <div class="table-container">
    <table aria-label="linked" mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
            class="checkbox-select mt-2 mr-1">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="shipmentID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.mawList.motherBBX' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" (click)="NavToShipmentDetail($event)">
          {{ element.shipmentID }}
        </td>
      </ng-container>

      <ng-container matColumnDef="PieceID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.linkPieces.pieceID' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.pieceID }}</td>
      </ng-container>
      <ng-container matColumnDef="ctryCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.linkPieces.destinationCountryCode' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.destination_country }}
        </td>
      </ng-container>

      <ng-container matColumnDef="serviceCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'maw.linkPieces.destinationServiceCode' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.dest_srva_code }}</td>
      </ng-container>

      <ng-container matColumnDef="pieceStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span *ngIf="this.pieceLevelLabelPrint && pieceStatusExist">
            {{ 'maw.linkPieces.pieceStatus' | translate }}
          </span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="this.pieceLevelLabelPrint && pieceStatusExist"
            [ngClass]="{ 'alert-msg': element.status == 'Not Generated' }"
            >{{ element.status }}</span
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row justify-content-center" *matNoDataRow>
        {{
          'maw.linkPieces.noDataAvailable' | translate
        }}
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[15, 30, 45]" showFirstLastButtons></mat-paginator>
  </div>
</div>
